export const deleteStyle = {
  mainBox: {
    // width: '100%',
    height: 50,
    padding: 25,
    // background: '#FFFFFF',
    overflow: 'hidden',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    gap: 4,
  },
  mainTitle: {
    textAlign: 'center',
    color: 'grey.700',
    fontSize: 28,
    fontWeight: '600',
  },
  containeStyle: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: ' 8px',
    width: '170%',
  },

  subtitletext: {
    textAlign: 'center',
    color: 'grey.600',
    fontSize: 20,
    textWrap: 'wrap',
  },
  buttonContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    gap: 2,
    display: 'flex',
  },
  iconContainer: {
    width: 80,
    height: 80,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
};
